import React from 'react'
import { connect } from 'react-redux'
import { fetchOfficeData, setOpened, setBrNr, closeSignature } from 'state/actions'
import styles from "./index.scss"
import General from './General'
import { Finances } from './finances'
import Employees from './employees'
import Contacts from './contacts'
import Management from './management'
import AdminDocs from './AdminDocs'
import Signature from './signature'
import EmailSetup from './emailSetup'
import BrokerSelector from '../BrokerSelector'

import i18n from 'lib/i18n'
const _ = i18n('office')

// This relies on object iteration being specified-order, which it normally is
const SubNav = ({ currentId, items, onChange }) => (
	<div className={`${styles.headingDiv}`}>
		{Object.keys(items).map((moduleId) => (
			<div
				key={moduleId}
				className={`${styles.headingCell} info ${currentId === moduleId ? `${styles.active}` : ''}`}
				onClick={() => onChange(moduleId)}
			>
				{items[moduleId]}
			</div>
		))}
	</div>
)

@connect((state) => {
	const currentBrNr = state.app.brNr
	const brokers = state.office.brokers
	const subModule = state.app.opened || 'general'
	const officeData = state.office.brokers[currentBrNr]
	const security = state.app.security
	const clientAccess = state.app.security.actions
	const createmail = clientAccess &&
		clientAccess.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0
	const hasInternalAccess = state.app.userTypeId === '1' || state.app.userTypeId === '3' ? true : false

	// console.log('from connect currentBrNr: ', currentBrNr);
	// const hasInternalAccess = security.actions.filter((item) => (item.actionName == "internal" && item.actionAllowed == "true")).length > 0
	return {
		brokers,
		officeData,
		currentBrNr,
		subModule,
		security,
		createmail,
		signatureZoom: state.office.signatureZoom,
		hasInternalAccess
	}
})
export default class Index extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		officeData: React.PropTypes.object,
		brokers: React.PropTypes.object,
		currentBrNr: React.PropTypes.string,
		subModule: React.PropTypes.string,
		security: React.PropTypes.object,
		signatureZoom: React.PropTypes.object,
		createmail: React.PropTypes.bool,
	}

	componentDidMount() {
		const { dispatch, hasInternalAccess } = this.props
		dispatch(fetchOfficeData(hasInternalAccess))
	}
	setSubModule(subModuleName) {
		const { dispatch } = this.props
		dispatch(setOpened(subModuleName))
		dispatch(closeSignature())
	}

	render() {
		const { subModule, officeData, brNr, brokers, currentBrNr, security,
			createmail, dispatch, signatureZoom, hasInternalAccess } = this.props
		let output, tabItems = {
			general: _('info'),
			employees: _('workers'),
			contacts: _('contacts'),
			management: _('management'),
		}
		// compose the tab items by security attributes in order
		let extraTabs = { finances: _('accounting') }
		let lastTabs = { adminDocs: _('adminDocs') }
		if (createmail) {
			lastTabs['signature'] = _('signature')
		}

		lastTabs['emailSetup'] = _('emailSetup')

		const extraIsVisible = security && security.brokerAccountingVisible
			&& security.brokerAccountingVisible === "true" && true || false
		tabItems = extraIsVisible && { ...tabItems, ...extraTabs } || tabItems
		tabItems = { ...tabItems, ...lastTabs }

		switch (subModule) {
			case 'general':
				output = <General />
				break
			case 'employees':
				output = <Employees />
				break
			case 'contacts':
				output = <Contacts />
				break
			case 'management':
				output = <Management />
				break
			case 'finances':
				output = <Finances />
				break
			case 'adminDocs':
				output = <AdminDocs />
				break
			case 'signature':
				output = <Signature dispatch={dispatch} />
				break
			case 'emailSetup':
				output = <EmailSetup dispatch={dispatch} />
				break
			default:
				output = <div>Unknown submodule!</div>
				break
		}

		// if (!officeData) {
		// 	return false
		// }

		// you can not change broker when editing a signature.
		let brokerSelectorIsDisabled = Boolean((subModule == 'signature') && signatureZoom && signatureZoom.visible)
		// introduce internal security check 
		return (
			<div id={`${styles.officeModule}`}>
				<div className={`${styles.office}`}>
					<div className={`${styles.mainTitleDiv}`}>
						<div className={`${styles.mainTitleContainer}`}>
							<h2 className={`${styles.mainTitle}`}>
								{_('title')}
								<BrokerSelector
									brokers={brokers}
									setBrNr={setBrNr}
									brNr={currentBrNr}
									disabled={brokerSelectorIsDisabled}
									customClass={styles.officeNumber}
								/>
							</h2>
							<h3>{_('subtitle')}</h3>
						</div>
					</div>
					<div id={`${styles.officeNavigation}`}>
						<SubNav
							currentId={subModule}
							items={tabItems}
							onChange={id => this.setSubModule(id)}
						/>
					</div>
					<div id="officeMain" className={`module-wrap`}>
						{output}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/index.jsx